import { Link } from 'react-router-dom';

const Footer = () => {
  const scrollToContact = () => {
    window.REACT_APP_NAVIGATE('/iletisim');
  };

  return (
    <footer className="bg-gradient-to-br from-[#0A1428] via-[#0d1a35] to-[#0A1428] text-white relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-deep-cyan rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#007dff] rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20 relative z-10">
        {/* Main Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-12 mb-16">
          {/* Logo & About - Wider */}
          <div className="lg:col-span-4">
            <img 
              src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/b7cb55fc6b509ec5e4250af0e061f4f3.png" 
              alt="Sigorota360" 
              className="h-11 mb-5"
            />
            <p className="font-inter text-[15px] text-white/80 leading-relaxed mb-6 max-w-sm">
              Sigorta acentelerinin dijital büyüme partneri. Sosyal medyadan web tasarımına, reklamlardan CRM'e kadar tüm dijital ihtiyaçlarınız için yanınızdayız.
            </p>
            
            {/* Stats */}
            <div className="grid grid-cols-2 gap-4 mb-6">
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                <div className="text-2xl font-bold text-deep-cyan mb-1">120+</div>
                <div className="text-xs text-white/70 font-inter">Mutlu Acente</div>
              </div>
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                <div className="text-2xl font-bold text-deep-cyan mb-1">9+</div>
                <div className="text-xs text-white/70 font-inter">Yıllık Deneyim</div>
              </div>
            </div>

            {/* Social Media */}
            <div className="flex items-center gap-3">
              <a href="https://www.linkedin.com/company/sigorota360" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-xl hover:bg-deep-cyan hover:scale-110 transition-all duration-300 cursor-pointer border border-white/10 group">
                <i className="ri-linkedin-fill text-lg group-hover:scale-110 transition-transform"></i>
              </a>
              <a href="https://www.instagram.com/sigorota360/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-xl hover:bg-deep-cyan hover:scale-110 transition-all duration-300 cursor-pointer border border-white/10 group">
                <i className="ri-instagram-line text-lg group-hover:scale-110 transition-transform"></i>
              </a>
            </div>
          </div>

          {/* Hizmetler */}
          <div className="lg:col-span-3">
            <h3 className="font-poppins font-bold text-base mb-5 text-white flex items-center gap-2">
              <span className="w-1 h-5 bg-deep-cyan rounded-full"></span>
              Hizmetler
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/hizmetler/sosyal-medya" className="font-inter text-[14px] text-white/70 hover:text-deep-cyan hover:translate-x-1 transition-all duration-300 flex items-center gap-2 group">
                  <i className="ri-arrow-right-s-line text-deep-cyan opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Sosyal Medya Yönetimi
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/dijital-reklamcilik" className="font-inter text-[14px] text-white/70 hover:text-deep-cyan hover:translate-x-1 transition-all duration-300 flex items-center gap-2 group">
                  <i className="ri-arrow-right-s-line text-deep-cyan opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Meta & Google Reklamları
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/web-tasarim" className="font-inter text-[14px] text-white/70 hover:text-deep-cyan hover:translate-x-1 transition-all duration-300 flex items-center gap-2 group">
                  <i className="ri-arrow-right-s-line text-deep-cyan opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Web Tasarımı
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/crm-otomasyon" className="font-inter text-[14px] text-white/70 hover:text-deep-cyan hover:translate-x-1 transition-all duration-300 flex items-center gap-2 group">
                  <i className="ri-arrow-right-s-line text-deep-cyan opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  CRM & Otomasyon
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/marka-kimligi" className="font-inter text-[14px] text-white/70 hover:text-deep-cyan hover:translate-x-1 transition-all duration-300 flex items-center gap-2 group">
                  <i className="ri-arrow-right-s-line text-deep-cyan opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Marka Kimliği
                </Link>
              </li>
              <li>
                <Link to="/hizmetler/video-produksiyon" className="font-inter text-[14px] text-white/70 hover:text-deep-cyan hover:translate-x-1 transition-all duration-300 flex items-center gap-2 group">
                  <i className="ri-arrow-right-s-line text-deep-cyan opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Video Prodüksiyon
                </Link>
              </li>
            </ul>
          </div>

          {/* Kurumsal */}
          <div className="lg:col-span-2">
            <h3 className="font-poppins font-bold text-base mb-5 text-white flex items-center gap-2">
              <span className="w-1 h-5 bg-deep-cyan rounded-full"></span>
              Kurumsal
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/hakkimizda" className="font-inter text-[14px] text-white/70 hover:text-deep-cyan hover:translate-x-1 transition-all duration-300 flex items-center gap-2 group">
                  <i className="ri-arrow-right-s-line text-deep-cyan opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/paketler" className="font-inter text-[14px] text-white/70 hover:text-deep-cyan hover:translate-x-1 transition-all duration-300 flex items-center gap-2 group">
                  <i className="ri-arrow-right-s-line text-deep-cyan opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Paketler
                </Link>
              </li>
              <li>
                <Link to="/akademi" className="font-inter text-[14px] text-white/70 hover:text-deep-cyan hover:translate-x-1 transition-all duration-300 flex items-center gap-2 group">
                  <i className="ri-arrow-right-s-line text-deep-cyan opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Dijital Akademi
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="font-inter text-[14px] text-white/70 hover:text-deep-cyan hover:translate-x-1 transition-all duration-300 flex items-center gap-2 group">
                  <i className="ri-arrow-right-s-line text-deep-cyan opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          {/* İletişim & CTA */}
          <div className="lg:col-span-3">
            <h3 className="font-poppins font-bold text-base mb-5 text-white flex items-center gap-2">
              <span className="w-1 h-5 bg-deep-cyan rounded-full"></span>
              İletişim
            </h3>
            
            <div className="space-y-4 mb-6">
              <a href="mailto:info@sigorota360.com" className="flex items-center gap-3 text-white/70 hover:text-deep-cyan transition-colors group">
                <div className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-lg group-hover:bg-deep-cyan transition-all">
                  <i className="ri-mail-line text-base"></i>
                </div>
                <span className="font-inter text-[14px]">info@sigorota360.com</span>
              </a>
              
              <a href="tel:+905530161235" className="flex items-center gap-3 text-white/70 hover:text-deep-cyan transition-colors group">
                <div className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-lg group-hover:bg-deep-cyan transition-all">
                  <i className="ri-phone-line text-base"></i>
                </div>
                <span className="font-inter text-[14px]">0553 016 12 35</span>
              </a>
            </div>

            <Link
              to="/teklif-al"
              className="w-full px-6 py-3.5 bg-gradient-to-r from-deep-cyan to-[#0d9488] text-white text-[14px] font-semibold rounded-xl hover:shadow-xl hover:shadow-deep-cyan/30 hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer font-poppins flex items-center justify-center gap-2 group"
            >
              Hemen Teklif Al
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
            <p className="font-inter text-[13px] text-white/60">
              © 2025 <strong className="text-white/80">Sigorota360</strong>. Tüm hakları saklıdır.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/gizlilik-politikasi" className="font-inter text-[13px] text-white/60 hover:text-deep-cyan transition-colors">
                Gizlilik Politikası
              </Link>
              <Link to="/kullanim-kosullari" className="font-inter text-[13px] text-white/60 hover:text-deep-cyan transition-colors">
                Kullanım Koşulları
              </Link>
              <a 
                href="https://cdco.com.tr" 
                target="_blank" 
                rel="nofollow noopener noreferrer" 
                className="font-inter text-[13px] text-white/50 hover:text-deep-cyan transition-colors"
              >
                Bu bir CDCO markasıdır
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
